module.exports = __webpack_public_path__ + "static/media/invest.47f86090.jpg";